import React from 'react';
import styles from './style.module.scss';
import { PropsWithTestId } from 'types';

export type StatisticProps = PropsWithTestId<{
  value: string;
  label: string;
}>;

export default function Statistic({ value, label, testId }: StatisticProps) {
  return (
    <div className={styles.stat} data-testid={testId}>
      <div className={styles['stat-number']}>
        {value}
      </div>
      <div className={styles['stat-description']}>
        {label}
      </div>
    </div>
  );
}
